import React from 'react';

import {IconBus} from '../Icons';

const TransitBadge = props => {
    const leg = props.leg;
    let routeColor = 'transparent';
    if (leg.routeColor) {
        routeColor = formatHexColorString(leg.routeColor);
    }
    let textColor = '#000';
    if (leg.routeTextColor) {
        textColor = formatHexColorString(leg.routeTextColor);
    }
    const iconStyle = {
        background: routeColor,
        color: textColor,
        fill: textColor
    };
    return (
        <div className="otp-trip-icon otp-padded-icon" style={iconStyle}>
            <IconBus /> { props.showName && getRouteBadgeName(leg) }
        </div>
    );
};

function formatHexColorString(hexString) {
    if (!hexString.startsWith('#')) {
        return '#' + hexString;
    }
    return hexString;
}

function getRouteBadgeName(leg) {
    if (leg.routeShortName) {
        return leg.routeShortName;
    }
    if (leg.route) {
        return leg.route;
    }
    return leg.routeLongName;
}

TransitBadge.defaultProps = {
    showName: true
};

export default TransitBadge;